import React from "react";

const thumbStyle = {
  width: 48,
  height: 48,
  objectFit: "contain",
  borderRadius: 4,
};

/** @param {(key: string) => string} tk */
export function getPartnerColumns(tk) {
  return [
    {
      key: "logo_url",
      label: tk("columns.logo"),
      render: (row) =>
        row.logo_url ? (
          <img src={row.logo_url} alt="" style={thumbStyle} />
        ) : (
          tk("table.emptyCell")
        ),
    },
    { key: "name_en", label: tk("columns.nameEn") },
    { key: "name_ar", label: tk("columns.nameAr") },
  ];
}
